/** Поведение при невозможности достичь указанный шаг (не касается первого шага) **/
export var EStepUnreachableErrorPolicy;

(function (EStepUnreachableErrorPolicy) {
  EStepUnreachableErrorPolicy["Error"] = "error";
  EStepUnreachableErrorPolicy["MoveFirst"] = "moveFirst";
})(EStepUnreachableErrorPolicy || (EStepUnreachableErrorPolicy = {}));